// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3w7ws","errors":"Errors_errors__1cmb3"};